import { Paragraph } from "App/global-style";
import styled from "styled-components";

export const Fieldset = styled.fieldset`
  border: 0;
  display: flex;
  flex-direction: column;

  & + * {
    margin-top: 32px;
  }
`;

export const Legend = styled.legend`
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 8px;
`;

export const Hint = styled(Paragraph)`
  font-size: 14px;
  margin-bottom: 0;
`;

export const OptionContainer = styled.div`
  & > * + * {
    margin-top: 8px;
  }

  @media (min-width: 600px) {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    & > * + * {
      margin-top: 0;
    }

    & > * {
      height: 50px;
      max-width: 48%;
      width: 100%;
    }

    & > *:nth-child(even) {
      margin-left: 8px;
    }

    & > *:nth-child(n + 3) {
      margin-top: 8px;
    }
  }
`;

export const Label = styled.label<{ checked?: boolean }>`
  align-items: center;
  background-color: ${({ checked, theme }) =>
    checked ? theme.insuranceDetailsCard.backgroundColor ?? "#F5E4C7" : "#fff"};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  justify-content: space-between;
  line-height: 24px;
  padding: 12px;

  & > *:last-child {
    max-height: 25px;
    max-width: 25px;

    & > svg {
      max-height: 25px;
    }
  }
`;

export const LabelText = styled.span`
  flex-grow: 1;
  padding: 0 8px;
`;

export const Radio = styled.input`
  appearance: none;
  background-color: ${({ theme }) => theme.brandColors.white};
  border: ${({ theme }) => `1px solid ${theme.brandColors.black}`};
  border-radius: 99px;
  height: ${({ theme }) => theme.spacing.sm};
  margin-right: ${({ theme }) => theme.spacing.sm};
  min-width: ${({ theme }) => theme.spacing.sm};
  position: relative;
  width: ${({ theme }) => theme.spacing.sm};

  &:checked {
    background-color: ${({ theme }) =>
      theme.insuranceDetailsCard.textColor ?? theme.brandColors.gray};
    border-color: ${({ theme }) =>
      theme.insuranceDetailsCard.textColor ?? theme.brandColors.gray};
  }

  &:checked::after {
    background-color: ${({ theme }) => theme.brandColors.white};
    border-radius: 99px;
    content: "";
    display: inline-block;
    height: 6px;
    left: 4px;
    position: absolute;
    top: 4px;
    width: 6px;
  }
`;

export const BicycleRegistryDescription = styled.p`
  font-weight: 600;
  margin-top: -10px;

  & a {
    font-weight: 600;
  }
`;
